enum InternalReportRecruiterTypeEnum {
  ExternalRecruiter = 'externalRecruiter',
}

export { InternalReportRecruiterTypeEnum };
